import { useModel } from '../model'
import { ISearchValue, SearchTypeEnum } from '@/components/YhPageHeader/Types'
import { YhPageHeader } from '@/components/YhPageHeader'
import useGlobalModel from '@/model/globalModel'
import { useDictModel } from '@/views/base/dict/dictModel'
import { DictCodeEnmu } from '@/types/AppDictEnums'
import { arrayNonRepeatfy } from '@/utils/utils'

export function PageHeader() {
    const {
        user: { branch },
    } = useGlobalModel()
    const { getSelectedDictOne } = useDictModel(() => [])
    const { searchParam, updateSearchParam, resetSearchParam, loadData } = useModel()
    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            placeholder: '入库单号',
            fieldName: 'code',
            span: 4,
        },
        {
            type: SearchTypeEnum.Select,
            placeholder: '入库类型',
            fieldName: 'tradeTypeCode',
            span: 4,
            options: getSelectedDictOne(branch, 'enterWarehouse', DictCodeEnmu.TRADE_TYPE),
        },
        {
            type: SearchTypeEnum.Select,
            placeholder: '单据状态',
            fieldName: 'status',
            span: 5,
            options: arrayNonRepeatfy(getSelectedDictOne(branch, 'enterWarehouse', DictCodeEnmu.TRADE_STSTUS), 'value'),
            mode: 'multiple',
        },
        {
            type: SearchTypeEnum.RangePicker,
            fieldName: '',
            title: '入库时间',
            rangePickerFieldName: ['startTime', 'endTime'],
            placeholder: ['入库开始时间', '入库结束时间'],
            format: 'YYYY-MM-DD',
            span: 5,
        },
    ]

    return (
        <YhPageHeader
            title=""
            size="small"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={resetSearchParam}
        />
    )
}
